module.exports = __webpack_public_path__ + "img/gongzhonghao.1dda0bc4.png";